export default __webpack_public_path__ + "static/media/Tarro de leche.486d3d69.jpeg";